import { FC, useEffect, useState } from 'react';
import { TableApi } from '../../../services/modules/table';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import tableStyle from '../../assets/table.module.css';
import { downloadFile } from '../../../utils/file';
type TDataTableReadData = {
  header: Array<string>;
  table: {
    ins: Array<Array<any>>;
  };
};

/* eslint-disable no-unused-vars */
export const CounterDataDialog: FC<{
  show: boolean;
  close: () => void;
  dataTableParams: TableApi.TDataTableReadParams<TDataTableReadData>;
}> = ({ show, close, dataTableParams }) => {
  const [data, setData] = useState<any[]>([]);
  const [headers, setHeaders] = useState<string[]>([]);

  useEffect(() => {
    if (
      dataTableParams.data &&
      'header' in dataTableParams.data &&
      dataTableParams.data.header
    ) {
      setHeaders(dataTableParams.data.header);
    }

    if (
      dataTableParams.data &&
      'table' in dataTableParams.data &&
      dataTableParams.data.table
    ) {
      // Преобразование в массив объектов
      const arrayOfObjects = dataTableParams.data.table.ins.map(
        (innerArray) => {
          const innerObject: any = {};
          innerArray.forEach((value, innerIndex) => {
            innerObject['t' + innerIndex] = value;
          });

          return innerObject;
        }
      );
      setData(arrayOfObjects);
    }
  }, [dataTableParams]);

  const handleExport = async () => {
    const response = await TableApi.dataTableExport({
      format: 'excel',
      tableName: 'counter_data',
    });
    if (!response) return;
    const url = response.url;
    downloadFile(url);
  };

  return (
    <Dialog
      header={dataTableParams.tableCaption}
      visible={show}
      style={{
        width: 1200,
      }}
      onHide={close}
      footer={
        <div style={{ display: 'flex', justifyContent: 'end', width: '100%' }}>
          <Button
            type="button"
            tooltip="Экспорт"
            style={{ width: 50 }}
            severity="success"
            icon="pi pi-file-export"
            onClick={handleExport}
          ></Button>
        </div>
      }
    >
      <div
        className={tableStyle.tableContainer}
        style={{
          padding: 0,
        }}
      >
        <DataTable
          value={data}
          scrollable
          scrollHeight="600px"
          className={tableStyle.table}
          showGridlines
          size="small"
          emptyMessage="Ничего не найдено"
        >
          {headers.map((col, i) => (
            <Column key={i} field={String('t' + i)} header={col} />
          ))}
        </DataTable>
      </div>
    </Dialog>
  );
};
